/**
 * "用能方"、"运维公司"、"资方"或"用能方自投"
 */
export const CREATE_TENANT_TYPES = [3, 6, 9, 10];
